import { IntersectionObserverHooks, Attributes } from 'ng-lazyload-image';

export class CustomLazyLoadImageHooks extends IntersectionObserverHooks {
  override setup(attributes: Attributes): void {
    attributes.defaultImagePath =
      attributes.defaultImagePath || '/assets/images/broken-image.svg';

    super.setup(attributes);
  }

  override setErrorImage(
    error: unknown,
    { element, errorImagePath }: Attributes
  ): void {
    if (element instanceof HTMLImageElement) {
      element.src = errorImagePath || '/assets/images/broken-image.svg';
    }
  }
}
